// extracted by css-extract-rspack-plugin
export default {"plainLink":"KGFsy"};